<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            Gasto Folio:{{folio}}
            <div>
              <router-link :to="{
                      name: 'EditGasto',
                      params: {
                        folio: folio,
                        config: config
                      }
                    }">
                <CButton v-if="false" color="success" class="mr-1 btn-header">
                  <CIcon class="mr-1" name="cil-pencil" />Editar
                </CButton>
              </router-link>
              <CButton color="info" class="mr-1 btn-header" @click="getReporte">
                <i v-if="loader" class="fa fa-spinner fa-pulse mr-1"></i>
                <CIcon v-else class="mr-1" :name="`cil-cloud-download`" />PDF
              </CButton>
              <router-link :to="{ name: 'Gasto', params: { config: config }  }">
                <CButton color="primary" class="mr-1 btn-header">
                  <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
                </CButton>
              </router-link>
            </div>
          </CCardHeader>

          <CCardBody v-if="isLoading">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>

          <CCardBody v-else>
            <CCol sm="12" class="text-right">
              {{ this.item.author.correo }}
            </CCol>
            <CRow>
              <CCol>
                <label>Fecha:</label>
                <CInput v-model="date" disabled type="date" horizontal />
              </CCol>
            </CRow>

            <CRow>
              <CCol md="9" lg="9" xl="9">
                <label>Empresa:</label>
                <CInput
                  disabled
                  v-model="empresa"
                  :horizontal="{ input: 'col-sm-12' }"
                  placeholder="Empresa"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="9" md="9" lg="9">
                <label>Ubicaciones:</label>
                <multiselect
                  v-model="multi"
                  :options="ubicaciones"
                  disabled
                  class="margin-multi"
                  :multiple="true"
                  label="label"
                  track-by="label"
                  placeholder="Selecciona uno o varias ubicaciones"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol md="9" lg="9" xl="9">
                <label>Gasto:</label>
                <CInput
                  disabled
                  v-model="servicio"
                  :horizontal="{ input: 'col-sm-12' }"
                  placeholder="Gasto"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol md="9" lg="9" xl="9">
                <label>Folio Factura:</label>
                <CInput
                  disabled
                  v-model="folio_factura"
                  :horizontal="{ input: 'col-sm-12' }"
                  placeholder="Folio Factura"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol md="9" lg="9" xl="9">
                <label>Proveedor:</label>
                <CInput
                  disabled
                  v-model="proveedor"
                  :horizontal="{ input: 'col-sm-12' }"
                  placeholder="Proveedor"
                />
              </CCol>
            </CRow>
            
            <CRow>
              <CCol md="9" lg="9" xl="9">
                <label>Costo unitario:</label>
                <CInput disabled v-model="costo" placeholder="Costo unitario" type="number" />
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <label>Comentarios:</label>
                <CTextarea v-model="comentarios" disabled horizontal />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <KlayFileDD
                  :fetching="fetching"
                  v-model="medias"
                  :label="`Anexos: `"
                  @onFetch="onFetch"
                  @onErrorFetch="(err)=>{
                    fetching=false;
                    error=err
                    warningModal=true
                  }"
                  :fetchMethod="pushMedia"
                  :baseSrc="$store.getters.MediaGet"
                />
              </CCol>
            </CRow>
            <CRow>
              <CButton v-if="fetching" class="px-4 mx-3 btn-lg" color="success">
                <i class="fa fa-spinner fa-pulse"></i>
              </CButton>
              <CButton v-else @click="()=>{fetching=true}" class="px-4 mx-3 btn-lg" color="success">
                <span>Actualizar</span>
              </CButton>
            </CRow>
            <CModal
              size="sm"
              title="Gasto"
              :centered="true"
              color="warning"
              :show.sync="warningModal"
            >{{ error }}</CModal>
            <CModal
              size="sm"
              title="Gasto"
              :centered="true"
              color="success"
              :show.sync="successModal"
              >Guardado con éxito.
              <template #footer>
                <CButton @click="successModal = false"  color="success">Aceptar</CButton>
              </template>
            </CModal>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "NuevoGasto",

  components: {
    Multiselect
  },

  data() {
    return {
      folio: this.$route.params.id,
      config: this.$route.params.config,
      item: {},
      multi: null,
      ubicaciones: [],
      ubicacionesAll: [],
      detalles: [],
      date: null,
      unidad: "Unidad",

      folio_factura: '',
      servicio: null,
      proveedor: null,
      empresa: null,
      serviciosAll: [],
      cantidad: null,
      costo: null,
      comentarios: '',
      successModal: false,
      warningModal: false,
      error: "",
      isLoading: false,
      isLoadingPage: false,
      currentAlertCounter: 0,
      fetching: false,
      medias:[],
      loader: false,
    };
  },

  computed: {
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  created() {
    this.isLoading = true;
    this.$store;

    const ubi = [
      this.$store.dispatch("customDocumentoHTTP", {
        schema: "gastos",
        filter: {
          wherein: [
            {
              field: "payload->encabezado->ubicacion_raiz_id",
              value: [this.ubicacionRaiz]
            }
          ],
          where: [
            {
              field: "folio",
              value: this.folio,
              operator: "="
            }
          ]
        },
        ["with-storage"]:["*"]
      })
    ];

    Promise.all(ubi)
      .then(([item]) => {
        this.item = item.data[0];

        const newMult = this.item.payload.encabezado._relaciones.ubicacion
            .filter(ubi => ubi.id)
            .map(ubicacion => {
              return { value: ubicacion.id, label: ubicacion.payload.nombre };
            });
        this.multi = newMult;

        this.servicio = this.item.payload.encabezado._relaciones.servicio?.payload?.nombre||'';
        this.proveedor = this.item.payload.encabezado._relaciones.proveedor?.payload?.nombre||'';
        this.empresa = this.item.payload.encabezado._relaciones.empresa?.payload?.nombre||'';
        this.costo = this.item.payload.encabezado.costo;
        this.folio_factura = this.item.payload.encabezado?.folio_factura||'';
        this.comentarios = this.item.payload.encabezado.comentarios;
        this.medias = this.item.payload.anexos;

        let dateDocto = new Date(this.item.payload.encabezado.fechahora);

        let year = dateDocto.getFullYear();
        let month = ("0" + (dateDocto.getMonth() + 1)).slice(-2);
        let day = ("0" + dateDocto.getDate()).slice(-2);

        this.date = `${year}-${month}-${day}`;
      })
      .finally(() => (this.isLoading = false));
  },

  methods: {
    getReporte(){
      if(this.loader){
        return
      }
      this.loader = true
      this.$forceUpdate();
      const reportCall = {
        reporte: "formato_gastos",
        params: { folio:this.$route.params.id, ubicaciones: [this.ubicacionRaiz]},
        pdf : true
      };

      // console.log(reportCall);
      // call.push(reportCall);

      
        this.$store.dispatch("reportsPDFHttp", {
          ...reportCall
        }).then(res => {

          const blob = res;

          let a = document.createElement("a");
          a.style = "display: none";
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = "Reporte de gastos.pdf";
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.loader = false
          this.$forceUpdate();
        });
    },
    async onFetch(medias){
      this.fetching=false
      const {folio,serie,schema,payload} = this.item
      const body = Object.assign({},JSON.parse(JSON.stringify({folio,serie,schema,payload})))
      body.payload.anexos = medias
      delete body.payload.encabezado._relaciones
      this.$store.dispatch("customDocumentoRemplazarHTTP",body)
        .then(()=>{
          this.currentAlertCounter = 6;
            // console.log(res.data);
            // this.$router.push({ name: "Produccion" });
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
          this.fetching=false
          return;
        })

        .finally(() => {
          this.fetching=false
          if (!this.warningModal) {
            this.successModal = true;
          }
        });
      
    },
    async pushMedia(files) {
      const arr = [];
      
      for (const v of files.map(async (m) => {
        // eslint-disable-next-line no-extra-boolean-cast
        if(!!m.media){
          return Promise.resolve({data:m,status:"success"})
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;
        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
